import {Badge, Box, Card, Stack, Tooltip, Typography} from '@mui/material'
import {Mensaje, MensajeFields} from '../../types'
import {EntityWithIdFields} from 'src/types'
import CustomChip from 'src/@core/components/mui/chip'
import {Link} from 'react-router-dom'
import {rutaPorCodSistema} from 'src/pages/sistema/RefactorLayout'
import {dateFormatter} from 'src/utils/formatters'
import {CountryAvatar} from "../../../../components/icons/CountryAvatar";

export const MessageCardMobile = ({message}: { message: Mensaje }) => {
  const {[MensajeFields.DiasEnEtapa]: diasEnEtapa} = message

  const fechaIngresoEtapa = dateFormatter.toShortDate(message[MensajeFields.FechaIngresoEtapa])
  const fechaCreacion = dateFormatter.toShortDate(message[MensajeFields.FechaCreacion])

  return (
    <Link
      to={`/operacion/${rutaPorCodSistema[message[MensajeFields.CodSistemaTipo]]}/${
        message[EntityWithIdFields.Id]
      }`}
      style={{textDecoration: 'none'}}
    >
      <Card sx={{height: '100%', p: 2}}>
        <Box display='flex' justifyContent='space-between' alignItems='center' gap={1}>
          <Stack direction='row' display='flex' alignItems='center' spacing={1} minWidth={0}>
            <CountryAvatar
              countryCode={message[MensajeFields.CodigoSistemaPrincipal]}
              sx={{height: '13px', width: '13px', flexShrink: 0}}
            />
            <Tooltip title={message[MensajeFields.Referencia]}>
              <Typography noWrap variant='caption' color='text.secondary' sx={{minWidth: 0}}>
                <Box component='span' sx={{fontWeight: 600}}>
                  Ref.:{' '}
                </Box>
                {message[MensajeFields.Referencia]}
              </Typography>
            </Tooltip>

          </Stack>
          <Badge color='error' variant='dot' invisible={message[MensajeFields.BitAbierto]} />
        </Box>
        <Stack spacing={0.25}>
          <Tooltip title={message[MensajeFields.NombreSistema]}>
            <Typography noWrap sx={{minWidth: 0, fontWeight: 700}}>
              {message[MensajeFields.NombreSistema]}
            </Typography>
          </Tooltip>
          <Tooltip title={message[MensajeFields.NombreEtapaActual]}>
            <Typography noWrap variant='caption'>
              <Box component='span' sx={{fontWeight: 600}}>
                Etapa:{' '}
              </Box>
              {message[MensajeFields.NombreEtapaActual]}
            </Typography>
          </Tooltip>
          <Stack direction='row' display='flex' alignItems='center' justifyContent='space-between'
          sx={{backgroundColor: '#efeff0', p:0.5, borderRadius: 1}}
          >
            <Typography noWrap variant='caption'>
              {message[MensajeFields.Estado]}
            </Typography>

          </Stack>
          <Box>
            <Typography noWrap variant='caption'>
              <Box component='span' sx={{fontWeight: 600}}>
                Ingreso etapa:{' '}
              </Box>
              {fechaIngresoEtapa}
            </Typography>
            <CustomChip
              size='small'
              skin='light'
              color={diasEnEtapa < 6 ? 'success' : diasEnEtapa < 20 ? 'warning' : 'error'}
              sx={{
                fontSize: 11,
                height: 15
              }}
              label={diasEnEtapa == 0 ? 'hoy' : `hace ${diasEnEtapa} dia${diasEnEtapa > 1 ? 's' : ''}`}
            />
          </Box>
          <Box>
            <Typography noWrap variant='caption'>
              <Box component='span' sx={{fontWeight: 600}}>
                Creación:{' '}
              </Box>
              {fechaCreacion}
            </Typography>
          </Box>
          <Box>
            <Typography noWrap variant='caption'>
              <Box component='span' sx={{fontWeight: 600}}>
                Id:{' '}
              </Box>
              {message[EntityWithIdFields.Id]}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </Link>
  )
}
